import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useState } from 'react';
import Draggable from 'react-draggable';

import { CallActionsPanel } from '@gem/call/CallView/Shared/CallActionsPanel/CallActionsPanel';
import { FullScreenButton } from '@gem/call/CallView/Shared/FullScreenButton/FullScreenButton';
import { OpponentVideo } from '@gem/call/CallView/Shared/OpponentVideo/OpponentVideo';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import { useMinimizedCallViewPresenter } from './MinimizedCallView.presenter';
import styles from './MinimizedCallView.styles.m.css';

interface IMinimizedCallViewProps {
  minimisedViewRedirectPath?: string;
}

export const MinimizedCallView: FC<IMinimizedCallViewProps> = observer(() => {
  const [isDragging, setDragging] = useState<boolean>();
  const presenter = useMinimizedCallViewPresenter();

  return (
    <Draggable
      cancel="button"
      bounds={'body'}
      onStart={(): void => setDragging(false)}
      onDrag={(): void => setDragging(true)}
      onStop={(): void => setDragging(false)}
    >
      <div
        className={classNames(styles.container, {
          [styles.dragging]: isDragging,
        })}
      >
        {presenter.videoOpponent && (
          <OpponentVideo
            opponent={presenter.videoOpponent}
            avatarType={AvatarTypes.Round_30}
            containerClassName={styles.videoContainer}
            className={styles.video}
            isMinimize={true}
          />
        )}

        <div
          className={classNames(styles.actionsPanel, {
            [styles.hidableContainer]: presenter.videoOpponent?.hasVideo,
          })}
        >
          <FullScreenButton className={styles.expandButton} />
          <div className={styles.actionsPanelContainer}>
            <CallActionsPanel
              className={styles.actionPanel}
              isMinimised
            />
          </div>
        </div>
      </div>
    </Draggable>
  );
});
